<template lang="pug">
  #app
    v-app
      router-view
</template>

<script>

export default {
  name: 'app',
}
</script>

<style lang="sass">
  body, html
    margin: 0
    padding: 0
    height: 100%
    font-size: 14px

    .v-application
      background-color: white !important
      font-family: 'Poppins', sans-serif !important
      color: $nightBlueColor

    #app
      height: 100%

    figure
      margin: 0
      padding: 0

      img
        width: 100%
        height: 100%
</style>

